// Goldmine / GEO.GG frontend entry.
// Imports the SCSS bundle; any future interactive JS
// (audit polling, shop-cart, telegram pairing UI) goes here.
import "./styles/app.scss";
import { initCarousels } from "./scripts/carousel";
import { initThemeToggle } from "./scripts/theme-toggle";

// Mobile language picker: the native <select class="lang-select"> shown
// below 860px navigates to the chosen locale path. Each <option value>
// is the target URL ("/<loc><request_path>"), so a change just assigns
// window.location. No-JS desktop falls back to the .lang-switch links.
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll<HTMLSelectElement>("select.lang-select").forEach(
    (select) => {
      select.addEventListener("change", (event) => {
        window.location.href = (event.target as HTMLSelectElement).value;
      });
    },
  );

  initCarousels();
  initThemeToggle();
});
